import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

/* Token storage — same-origin, persisted across reloads.
 * Why: iOS Safari (and increasingly all major browsers under ITP/cookie
 * partitioning) can silently drop cookies on cross-site fetches even when
 * `SameSite=None; Secure` is set. The backend already accepts the same
 * JWT via `Authorization: Bearer <token>` as a fallback path — we just
 * need to send it. This makes auth bulletproof regardless of cookie
 * behavior. Cookies stay enabled too (belt + suspenders). */
export const TOKEN_STORAGE_KEY = "cd_auth_token";

export function getStoredToken() {
  if (typeof window === "undefined") return "";
  try {
    return window.localStorage.getItem(TOKEN_STORAGE_KEY) || "";
  } catch (_) {
    return "";
  }
}

export function setStoredToken(token) {
  if (typeof window === "undefined") return;
  try {
    if (token) window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
    else window.localStorage.removeItem(TOKEN_STORAGE_KEY);
  } catch (_) {
    /* private mode / storage quota — ignore */
  }
}

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach the persisted JWT to every outgoing request. If iOS Safari strips
// the auth cookie, the Bearer header keeps the user authenticated.
api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export function fmtErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  // iter46 — backend now returns {code, message} for auth failures.
  // Prefer .message over .code so users read the human copy.
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export default api;
